import { Component, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { form, FormField, maxLength, min, required } from '@angular/forms/signals';
import { CrearMesaReq, MesaRes } from '@core/interfaces/request-response/comanda.dto';
import { ComandaApiService } from '@core/services/api/comanda-api.service';
import { ToastService } from '@shared/services/toast.service';
import { UiInputNumber } from '@shared/components/ui';

@Component({
  selector: 'app-agregar-mesa',
  imports: [UiInputNumber, FormField],
  templateUrl: './agregar-mesa.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agregar-mesa.css',
})
export class AgregarMesa implements OnInit {
  ngOnInit(): void {
    if (this.mesaEditar()) {
      this.formulario().value.set({
        nombre: this.mesaEditar()!.nombre,
        capacidad: this.mesaEditar()!.capacidad,
      });
    }
  }
  // servicios
  private comandaApiService = inject(ComandaApiService);
  private toastService = inject(ToastService);
  // Formulario con signals
  mesaEditar = input<MesaRes>();

  formulario = form(
    signal({
      nombre: this.mesaEditar()?.nombre || '',
      capacidad: this.mesaEditar()?.capacidad || 1,
    }),
    (x) => {
      required(x.nombre, { message: 'El nombre es obligatorio' });
      maxLength(x.nombre, 50, { message: 'El nombre no puede tener más de 50 caracteres' });
      min(x.capacidad, 1, { message: 'La capacidad debe ser al menos 1' });
    },
  );

  cerrar = output<void>();

  private checkFormInvalid(): boolean {
    if (this.formulario().invalid()) {
      this.formulario.nombre().touched();
      this.formulario.capacidad().touched();
      return true;
    }
    return false;
  }
  enviarFormulario(event: Event): void {
    event.preventDefault();
    if (this.checkFormInvalid()) return;
    const { nombre, capacidad } = this.formulario().controlValue();
    const rq: CrearMesaReq = { nombre, capacidad };
    if (this.mesaEditar()) {
      if (this.mesaEditar()!.nombre === nombre && this.mesaEditar()!.capacidad === capacidad) {
        this.toastService.show(
          'top-right',
          'info',
          'Sin cambios',
          'No se realizaron cambios en la mesa.',
        );
        return;
      }
      this.comandaApiService.actualizarMesa(this.mesaEditar()!.id, rq).subscribe({
        next: (rs) => {
          this.limpiarFormulario();
          this.cerrar.emit();
        },
        error: (err) => {
          if (err.status == 401) return;
          this.toastService.show(
            'top-right',
            'error',
            'Error',
            err.error?.message || 'No se pudo actualizar la mesa.',
          );
          console.error('Error al actualizar mesa:', err);
        },
      });
    } else {
      this.comandaApiService.crearMesa(rq).subscribe({
        next: (rs) => {
          this.limpiarFormulario();
          this.cerrar.emit();
        },
        error: (err) => {
          if (err.status == 401) return;
          this.toastService.show(
            'top-right',
            'error',
            'Error',
            err.error?.message || 'No se pudo crear la mesa.',
          );
          console.error('Error al crear mesa:', err);
        },
      });
    }
  }

  limpiarFormulario(): void {
    this.formulario().reset({
      nombre: '',
      capacidad: 1,
    });
  }
}
